<template>
  <div>

    <div class="items flex-row">
      <div v-for="(item, key) in entity.items" :key="key" class="flex-row align-items-center">
        <div>
          {{key + 1}}. &nbsp;
        </div>
        <ImageView v-if="item.image" :src="item.image" :desc="item.imageDesc"></ImageView>
        <pinyin :text="item.text" :pinyin="item.pinyin" v-else-if="item.pinyin"></pinyin>
        <div v-else>
          {{item.text}}
        </div>
      </div>
    </div>

    <ImageView v-if="entity.image" :src="entity.image" :desc="entity.imageDesc"></ImageView>

    <pinyin :text="entity.subject" :pinyin="entity.subjectPinyin" v-if="entity.subjectPinyin"></pinyin>
    <div v-else-if="entity.subject">
      {{entity.subject}}
    </div>

    <AudioView :src="entity.audio" :caption="entity.audioText" :caption-pinyin="entity.audioPinyin"></AudioView>

  </div>
</template>

<script>
import ImageView from './../../ImageView'
import AudioView from './../../AudioView'
import pinyin from './../../PinyinPreview'

export default {
  name: 'XktcView',
  components: { pinyin, ImageView, AudioView },
  props: {
    type: {
      type: Object,
      default: () => {
        return {}
      }
    },
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  }
}
</script>
